import { create } from 'zustand';
import { FeedbackModel, emptyFeedback } from 'model/feedback/FeedbackModels';

export interface FeedbackState {
    visited: Set<string>;
    updateVisited: (key: Set<string>) => void;
    violations: Map<string, string>;
    updateViolations: (map: Map<string, string>) => void;
    updateViolation: (key: string, value: any) => void;
    removeViolation: (key: string) => void;
    feedback: FeedbackModel;
    updateFeedback: (key: string, value: any) => void;
    setFeedback: (feedback: FeedbackModel) => void;
}

const useFeedbacks = create<FeedbackState>((set) => ({
    visited: new Set(),
    updateVisited: (key: Set<string>) => set((state: FeedbackState) => ({ 
        visited: key 
    })),
    violations: new Map(),
    updateViolations: (map: Map<string, string>) => set((state: FeedbackState) => ({ 
        violations: new Map(map)
    })),
    updateViolation: (key: string, value: any) => set((state: FeedbackState) => ({ 
        violations: new Map(state.violations).set(key, value)
    })),
    removeViolation: (key: string) => set((state: FeedbackState) => {
        const newMap = new Map(state.violations);
        newMap.delete(key);
        return { violations: newMap };
    }),
    feedback: emptyFeedback(),
    updateFeedback: (key: string, value: any) => set((state: FeedbackState) => ({ 
        feedback: {...state.feedback, [key]: value}
    })),
    setFeedback: (feedback: FeedbackModel) => set((state: FeedbackState) => ({ 
        feedback: feedback
    }))
}));

export default useFeedbacks;